import getNormalizedItems from "./getNormalizedItems";
import getElasticSrcAggregations from "./esUtils/getElasticSrcAggregations";
import isIElasticErrorResponse from "./esUtils/isIElasticErrorResponse";
const zeroResponse = () => {
    return {
        aggregations: [],
        itemsTotal: 0,
        items: [],
    };
};
export const normalizeElasticSrc = (elasticSrc) => {
    if (!elasticSrc) {
        return zeroResponse();
    }
    if (isIElasticErrorResponse(elasticSrc)) {
        console.warn("⚠️ normalizeElasticSrc", { elasticSrc });
        return zeroResponse();
    }
    const aggregations = getElasticSrcAggregations(elasticSrc);
    const items = getNormalizedItems(elasticSrc);
    return {
        aggregations,
        ...items,
    };
};
